import { UMIcon } from '../../urbanmap/_components';
import { distanceKm } from './domain';
import { PC, UMR, caption } from './tokens';
import type { LngLat, WeatherStation } from './types';

interface Props {
  stations: WeatherStation[];
  selected: string;
  center: LngLat | null;
  /** Station la plus proche du périmètre, proposée par défaut. */
  nearestId: string;
  onSelect: (id: string) => void;
}

/** Liste compacte : nom source puis degrés-jours explicitement simulés. */
export function StationList({ stations, selected, center, nearestId, onSelect }: Props) {
  const sorted = center
    ? [...stations].sort((a, b) => distanceKm(center, a.position) - distanceKm(center, b.position))
    : stations;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }} role="radiogroup" aria-label="Station météo du projet">
      {sorted.map((s) => {
        const active = s.id === selected;
        return (
          <button
            key={s.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onSelect(s.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left', cursor: 'pointer',
              padding: '4px 6px', background: active ? PC.accentBg : UMR.white,
              border: `1px solid ${active ? PC.accentBorder : 'transparent'}`, fontFamily: UMR.font,
              fontSize: 'var(--nj-semantic-font-size-text-xs)', lineHeight: 'var(--nj-semantic-size-spacing-16)', fontWeight: 400,
              color: UMR.black,
            }}
          >
            <UMIcon name={active ? 'radio_button_checked' : 'radio_button_unchecked'} size={18} color={active ? PC.accent : UMR.textSecondary} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {s.name}
              </span>
              <span style={{ ...caption, fontVariantNumeric: 'tabular-nums', display: 'flex', alignItems: 'center', gap: 'var(--nj-semantic-size-spacing-4)' }}>
                DJ standards {s.dju} / {s.djclim}
                {center && s.id === nearestId && <span className="pcv3-station-nearby">Proche</span>}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
